/**
 * Date-extensions locale Catalan [ca]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ca', {
    monthNames: ['Gener','Febrer','Març','Abril','Maig','Juny','Juliol','Agost','Setembre','Octubre','Novembre','Desembre'],
    monthShortNames: ['Gen.','Febr.','Març','Abr.','Maig','Juny','Jul.','Ag.','Set.','Oct.','Nov.','Des.'],
    dayNames: ['Diumenge','Dilluns','Dimarts','Dimecres','Dijous','Divendres','Dissabte'],
    dayShortNames: ['Dg.','Dl.','Dt.','Dc.','Dj.','Dv.','Ds.']
});
